/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  const reTarget = /^#nav-tab-/;
  $(this).scrollTop(0);

  $(window).on("load", function (e) {
    if (reTarget.test(location.hash)) {
      $(location.hash).click();
    }
  });
});
